import { render } from "./ExclusionAreaFormDialog.vue?vue&type=template&id=5e47437a"
import script from "./ExclusionAreaFormDialog.vue?vue&type=script&lang=js"
export * from "./ExclusionAreaFormDialog.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/GPSviaAIS/GPSviaAIS/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__